import { Stack } from '@mui/material';
import React from 'react';
import { useController, useFormContext } from 'react-hook-form';

import DatePicker from '../../../forms/DatePicker';
import Switch from '../../../forms/Switch';

export default function CustomSchedule() {
  const { control, getValues } = useFormContext();
  const { field: customScheduleEnabled } = useController({
    name: 'customSchedule.enabled',
    control,
  });

  const associated = getValues('association.associated');

  const defaultStartDate = getValues('customSchedule.defaultStartDate');
  const defaultEndDate = getValues('customSchedule.defaultEndDate');

  if (associated) {
    return (
      <Stack direction="row" spacing={2}>
        <Switch label="Custom Schedule" name="customSchedule.enabled" />
        {customScheduleEnabled.value && (
          <>
            <DatePicker
              name="customSchedule.startDate"
              label="Start Date (Eastern Time)"
              minDate={defaultStartDate}
              maxDate={defaultEndDate}
            />
            <DatePicker
              name="customSchedule.endDate"
              label="End Date (Eastern Time)"
              minDate={defaultStartDate}
              maxDate={defaultEndDate}
            />
          </>
        )}
      </Stack>
    );
  }

  return null;
}
